import { createAsyncThunk } from '@reduxjs/toolkit';
import { OrderAmountRemainingDTO, OrdersApi } from '@reposit/api-client';
import { AxiosResponse } from 'axios';
import { AppState } from '../root.reducer';
import { createStandardOrdersApi, runThunkWithAuth } from '../utils/api.utils';
import { FetchAmountRemainingForOrder } from './order.types';

export const fetchAmountRemainingForPaymentPlanOrderThunk = createAsyncThunk<
  number,
  FetchAmountRemainingForOrder,
  {
    state: AppState;
  }
>('order/amount-remaining', async (payload, thunkAPI) => {
  const state = thunkAPI.getState();
  const dispatch = thunkAPI.dispatch;
  const api: OrdersApi = createStandardOrdersApi(state, dispatch);
  const { orderId, includeInterest } = payload;

  const apiResponse: AxiosResponse<OrderAmountRemainingDTO> = await runThunkWithAuth(
    () => api.getAmountRemaining(orderId, includeInterest),
    dispatch,
  );
  const { amountRemaining } = apiResponse.data;
  return amountRemaining;
});

export const fetchAmountRemainingDetailsForOrderThunk = createAsyncThunk<
  OrderAmountRemainingDTO,
  Pick<FetchAmountRemainingForOrder, 'orderId'>,
  {
    state: AppState;
  }
>('order/amount-remaining-details', async ({ orderId }, thunkAPI) => {
  const state = thunkAPI.getState();
  const dispatch = thunkAPI.dispatch;
  const api: OrdersApi = createStandardOrdersApi(state, dispatch);

  const apiResponse: AxiosResponse<OrderAmountRemainingDTO> = await runThunkWithAuth(
    () => api.getAmountRemaining(orderId, true),
    dispatch,
  );
  return apiResponse.data;
});
